// import React, { useState, useEffect, useRef } from "react";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Api from "../../../../../api";

import styles from "./platform-list-header.module.scss";
import SVG from "../../../../../components/SVG";
import postalCodes from "../../../../../assets/images/postal-codes.png";
// function usePrevious(value) {
//   const ref = useRef();

//   // Store current value in ref
//   useEffect(() => {
//     ref.current = value;
//   }, [value]);
//   return ref.current;
// }

const HEADER_LINK = "#";

const renderIcon = {
  facebook: <SVG.FacebookPlatform />,
  snapchat: <SVG.Snapchat />,
  dv360: <SVG.Google360 />,
  adform: <SVG.AdForm />,
  googleAds: <SVG.GoogleAds />,
  ttd: <SVG.TheTradeDesk />,
  xandr: <img height={38} alt="xandr" width={42} src={SVG.Xandr} />,
  postalCode: <img style={{ width: 40 }} alt="postalCodes" src={postalCodes} />,
  llCoordinates: <SVG.LlCoords />,
  postalCodes: <img style={{ width: 40 }} alt="postalCodes" src={postalCodes} />
};
const renderTitle = {
  llCoordinates: "Download LL-Coordinates",
  postalCodes: "Download Postal Codes",
  ttd: "The Trade Desk",
  dv360: "DV360"
};

const PlatformsListHeader = ({ selectedPlatform, audience }) => {
  const [audienceCompliance, setAudienceCompliance] = useState(null);

  // const prevAudienceState = usePrevious(audience);

  useEffect(() => {
    // Dont show audience messages for presets
    // if (!audience.audienceVariables || audience.id === prevAudienceState?.id)
    if (!audience.audienceVariables) return;

    const getAudienceCompliance = async () => {
      const type = audience.audienceVariables ? "audience" : "preset";

      const response = await Api.platforms.additional.getAudienceCompliance({
        id: audience.id,
        type: `${type}_id`
      });

      setAudienceCompliance(response);
    };

    getAudienceCompliance();
    // }, [audience.audienceVariables, audience.id, prevAudienceState?.id]);
  }, [audience.audienceVariables, audience.id]);

  const renderPlatformInfo = () => {
    return (
      <div className={styles.platformInfo}>
        {/* <div>Icon</div> */}
        {renderIcon[selectedPlatform] || ""}
        <div>
          <h2 className={styles.title}>
            {renderTitle[selectedPlatform] || selectedPlatform}
          </h2>
        </div>
        <div>
          <p>
            {audienceCompliance &&
              audienceCompliance[selectedPlatform]?.message}
          </p>
        </div>
        {audienceCompliance && audienceCompliance[selectedPlatform]?.link && (
          <div className={styles.link}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              target="_blank"
              rel="noreferrer noopener"
              href={audienceCompliance[selectedPlatform].link}
            >
              {audienceCompliance &&
                audienceCompliance[selectedPlatform].linkText}
            </a>
          </div>
        )}
      </div>
    );
  };
  return (
    <div>
      {selectedPlatform ? (
        // renderPlatformMessage()
        renderPlatformInfo()
      ) : (
        <div>
          <div>
            <h2 className={styles.title}>Platform Activation</h2>
          </div>
          <div className={styles.link}>
            <a href={HEADER_LINK} target="_blank" rel="noreferrer noopener">
              See an overview of how we integrate with the different platforms
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

//   return (
//     <div className="text-center pt-2">
//       {selectedPlatform && audienceCompliance ? (
//         renderPlatformMessage()
//       ) : (
//         <span className="text-center">
//           Which platform do you want to activate in?
//         </span>
//
//       )}
//     </div>
//   );
// };

export default PlatformsListHeader;

PlatformsListHeader.propTypes = {
  selectedPlatform: PropTypes.string.isRequired,
  audience: PropTypes.shape({
    audienceVariables: PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.shape({}))
    ),
    id: PropTypes.string
  }).isRequired
};
